export default __webpack_public_path__ + "static/media/high-school-3.e6ea500a.jpg";